import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MarketingShell from "@/components/MarketingShell";
import { PHOTOS } from "@/lib/photos";

const GALLERY = [
  { src: PHOTOS.danPortrait, alt: "Dan at the piano" },
  { src: PHOTOS.danPiano, alt: "Dan performing live" },
  { src: PHOTOS.danHands, alt: "Hands on the keys" },
];

export default function About() {
  return (
    <MarketingShell active="/about">
      <motion.section initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <p className="text-[10px] uppercase tracking-[0.32em] mb-3" style={{ color: "#F2D589" }}>
          About
        </p>
        <h1
          className="leading-[0.95]"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
            fontSize: "clamp(40px, 5.6vw, 84px)",
            textWrap: "balance",
            maxWidth: "20ch",
          }}
        >
          Jazz &amp; Jewish tradition, <em style={{ color: "#F2D589" }}>in conversation</em>.
        </h1>
      </motion.section>

      <section className="mt-12 grid md:grid-cols-[1fr_1.3fr] gap-10 items-start">
        <div
          className="rounded-2xl overflow-hidden border"
          style={{ borderColor: "rgba(255,255,255,0.12)", aspectRatio: "4 / 5" }}
        >
          <img src={PHOTOS.berryFamilyBW} alt="Dan Berry" className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div className="space-y-4 text-base sm:text-lg leading-relaxed" style={{ color: "rgba(245,239,227,0.82)" }}>
          <p>
            Hi, I&apos;m Dan. I&apos;m a pianist and composer playing
            where Jewish music meets the jazz and classical traditions
            I grew up on. High Holiday melodies, klezmer-soaked folk
            songs, and niggunim that take the listener somewhere exotic
            yet strangely familiar.
          </p>
          <p>
            Every performance is different. Not just improvised, but{" "}
            <em>responsive</em> to the room, to the people in it, to
            the echoes of where we all come from. Sometimes it&apos;s a
            wedding. Sometimes it&apos;s a name turned into a melody.
            Sometimes it&apos;s just a piano and a bunch of strangers who
            become a little less strange together.
          </p>
          <p>
            Jewish music today isn&apos;t a museum, it&apos;s a
            living, breathing creative practice. I&apos;m here to play it
            like it is.
          </p>
        </div>
      </section>

      <section className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
        {GALLERY.map((g) => (
          <div
            key={g.src}
            className="rounded-2xl overflow-hidden border"
            style={{ borderColor: "rgba(255,255,255,0.12)", aspectRatio: "4 / 5" }}
          >
            <img src={g.src} alt={g.alt} className="w-full h-full object-cover" loading="lazy" />
          </div>
        ))}
      </section>

      <section className="mt-16 flex flex-wrap gap-3">
        <Link
          to="/music"
          data-testid="about-cta-music"
          className="inline-flex items-center justify-center rounded-full px-6 h-12 text-sm uppercase tracking-[0.22em]"
          style={{ backgroundColor: "#F2D589", color: "#080419", fontWeight: 600 }}
        >
          Listen to Dan
        </Link>
        <Link
          to="/contact"
          data-testid="about-cta-contact"
          className="inline-flex items-center justify-center rounded-full px-6 h-12 text-sm uppercase tracking-[0.22em] border border-white/25 hover:bg-white/10 transition-colors"
        >
          Get in touch
        </Link>
      </section>
    </MarketingShell>
  );
}
